import React, {useEffect} from 'react';
import logoImg from './assets/logo.png';
import linkedinImg from './assets/linkedin.png';
import './res4city-footer.css';
import { getConfig } from '@edx/frontend-platform';

const R4CFooter = () => {
  const {LMS_BASE_URL, LOGO_URL, MARKETING_SITE_BASE_URL} = getConfig()

  useEffect(() => {
    console.log("!!LMS_BASE_URL, LOGO_URL, MARKETING_SITE_BASE_URL!!", LMS_BASE_URL, LOGO_URL, MARKETING_SITE_BASE_URL)
  })

  return (
    <div className="wrapper wrapper-footer">
      <footer className="footer content-wrapper main-container">
        <div className="logo_social_media_container">
          <img src={LOGO_URL} alt="logo image" className="r4c-footer-logo" />
        </div>
        <div className="footer_lists">
          <div className="footer_list">
            <ul className="footer_items">
              <li className="footer_list_item">
                <a href="https://www.res4city.eu/self-assessment/" className="footer_list_item_link">Self-Assessment</a>
              </li>
              <li className="footer_list_item">
                <a href={`${MARKETING_SITE_BASE_URL}/privacy`} className="footer_list_item_link">Privacy Policy</a>
              </li>
              <li className="footer_list_item">
                <a href={`${LMS_BASE_URL}/cookie_policy`} className="footer_list_item_link">Cookie Policy</a>
              </li>
              <li className="footer_list_item">
                <a href={`${MARKETING_SITE_BASE_URL}/tos`} className="footer_list_item_link">Terms and Conditions</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer_lists">
          <div className="footer_list">
            <ul className="footer_items">
              <li className="footer_list_item">
                <p className="footer_list_item_link" style={{fontWeight: 'bolder !important', fontSize: 'larger !important'}}>Our projects</p>
              </li>
              <li className="footer_list_item">
                <a href="https://www.res4city.eu/" className="footer_list_item_link">RES4CITY</a>
              </li>
              <li className="footer_list_item">
                <a href="https://www.sherlockproject.eu/" className="footer_list_item_link">SHERLOCK</a>
              </li>
              <li className="footer_list_item">
                <a href="https://www.coss.ac.kr/" className="footer_list_item_link">COSS</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer_lists">
          <div className="footer_list">
            <ul className="footer_items">
              <li className="footer_list_item">
                <p className="footer_list_item_link" style={{fontWeight: 'bolder !important', fontSize: 'larger !important'}}>Get in touch</p>
              </li>
              <li className="footer_list_item">
                <a href={`${MARKETING_SITE_BASE_URL}/contact`} className="footer_list_item_link">Contact Us</a>
              </li>
              <li className="footer_list_item">
                <a href={`${LMS_BASE_URL}/about`} className="footer_list_item_link">About us</a>
              </li>
              <li className="footer_list_item">
                <a href="https://www.linkedin.com/company/res4city/posts/?feedView=all" className="social_media_icon">
                  <img src={linkedinImg} alt="linkedin icon" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default R4CFooter;
